import { TimetableMeta } from 'src/store/models/timetable/index.js'

export default {
  computed: {
    activeTimetableProject () {
      return TimetableMeta.query().first()
    },
    isOldSchoolyear () {
      const meta = this.activeTimetableProject
      if (!meta) return false

      return this.$moment().isAfter(this.$moment(meta.ends_at).subtract(3, 'weeks'))
    }
  }
}
